// extracted by mini-css-extract-plugin
var _1 = "LevelUpModal__backdrop--sNHIk ModalGeneral__backdrop--gxZiG";
var _2 = "LevelUpModal__badge--Bd0s2";
var _3 = "LevelUpModal__badgeImg--e4qvd";
var _4 = "LevelUpModal__badgeText--CUVLj";
var _5 = "LevelUpModal__badgeTextBeastPart--sh7u8 LevelUpModal__badgeText--CUVLj";
var _6 = "LevelUpModal__badgeTextPuzzle--aIXTv LevelUpModal__badgeText--CUVLj";
var _7 = "LevelUpModal__badges--Ksr4Q";
var _8 = "LevelUpModal__bg--kTtwp ModalGeneral__bg--qeVmP";
var _9 = "LevelUpModal__contents--cDONY";
var _a = "LevelUpModal__label--Mf_GN";
var _b = "LevelUpModal__level--JSrfm";
var _c = "LevelUpModal__levelNum--QFZXK";
var _d = "LevelUpModal__levelOnly--xaaQ_";
var _e = "LevelUpModal__levelShine--oeU2G";
var _f = "LevelUpModal__main--G6ENE";
var _10 = "LevelUpModal__number--FtmdP";
var _11 = "LevelUpModal__shine--OH68N";
var _12 = "LevelUpModal__shine2--ZIHQY";
var _13 = "LevelUpModal__st1--y2vcd";
var _14 = "LevelUpModal__st2--Xw7Wx";
var _15 = "LevelUpModal__st3--QAPm2";
var _16 = "LevelUpModal__starsDecor--DOUzP";
var _17 = "LevelUpModal__starsDecorUnlocked--LJXYs LevelUpModal__starsDecor--DOUzP";
var _18 = "LevelUpModal__starsGroup--Bqzdm";
var _19 = "LevelUpModal__starsLeft--EjYqo LevelUpModal__starsGroup--Bqzdm";
var _1a = "LevelUpModal__starsRight--Ndujk LevelUpModal__starsGroup--Bqzdm";
var _1b = "LevelUpModal__unlockIcon--_Nka_";
var _1c = "LevelUpModal__unlockedTitle--QC3ZP";
export { _1 as "backdrop", _2 as "badge", _3 as "badgeImg", _4 as "badgeText", _5 as "badgeTextBeastPart", _6 as "badgeTextPuzzle", _7 as "badges", _8 as "bg", _9 as "contents", _a as "label", _b as "level", _c as "levelNum", _d as "levelOnly", _e as "levelShine", _f as "main", _10 as "number", _11 as "shine", _12 as "shine2", _13 as "st1", _14 as "st2", _15 as "st3", _16 as "starsDecor", _17 as "starsDecorUnlocked", _18 as "starsGroup", _19 as "starsLeft", _1a as "starsRight", _1b as "unlockIcon", _1c as "unlockedTitle" }
